import React from 'react'
import Grid from '@material-ui/core/Grid'
import Critere from '../../Component/CRM/Critere'
import MotifArchive from '../../Component/CRM/MotifArchivage'
import Qualite from '../../Component/CRM/Qualite'
import TypeClient from '../../Component/CRM/TypeClient'
import Onglet from '../../Component/CRM/Onglet'
import Civilite from '../../Component/CRM/Civilite'
import Relation from '../../Component/CRM/Relation'
import GestionCritere from '../../Component/CRM/GestionCritere'
import Utils from 'EurestoFonction/Utils'
import Bus from 'EurestoClass/Bus'

export default (class extends React.Component {

  constructor(props) {
    super(props)
    const index = this.crmConfiguration.findIndex(page => page.autorisation !== false)
    this.state = {
      UserTabSelected: index !== -1 && this.crmConfiguration[index].id || index,
      busGUID: Utils.uuidv4()
    }
  }

  crmConfiguration = [
    {
      nom: 'Critère',
      component: <Critere />,
    },
    {
      nom: 'Onglet',
      component: <Onglet />,
    },
    {
      nom: 'Critères => Onglets',
      component: <GestionCritere />,
    },
    {
      nom: 'Civilité',
      component: <Civilite />,
    },
    {
      nom: 'Qualité',
      component: <Qualite />,
    },
    {
      nom: 'Relation',
      component: <Relation />,
    },
    {
      nom: 'Type client',
      component: <TypeClient />,
    },
    {
      nom: 'Motif archive',
      component: <MotifArchive />,
    }
  ]

  componentWillUnmount() {
    Bus.$off('donnees_annexes_crm', this.state.busGUID)
  }

  componentDidMount() {
    Bus.$on('donnees_annexes_crm', id => {
      this.setState({ UserTabSelected: id })
    }, this.state.busGUID)
  }

  render() {
    return <Grid container style={{ margin: 0, padding: 0, width: '100%', position: 'relative' }} spacing={0}>
      <Grid item xs={12}>
        {
          this.crmConfiguration[this.state.UserTabSelected].component
        }
      </Grid>
    </Grid>
  }
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Page/CRM/index.js